<template>
  <div class="dropdown">
    <button data-toggle="dropdown" type="button" class="dropdown-toggle btn btn-outline-success">Add new</button>
    <div tabindex="-1" role="menu" class="dropdown-menu">
      <a href="#" class="dropdown-item" @click.prevent="addNewModal">Add Template</a>
      <a href="#" class="dropdown-item" @click.prevent="cloneModal">Clone Template</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object
  },
  methods: {
    addNewModal(e) {
      e.currentTarget.parentElement.classList.toggle('show')
      this.$emitter.emit('Modal', {
        name: 'template.create',
        data: {},
        $el: null
      })
    },
    cloneModal(e) {
      e.currentTarget.parentElement.classList.toggle('show')
      this.$emitter.emit('Modal', {
        name: 'template.clone',
        data: {},
        $el: null
      })
    }
  }
}
</script>
